module.exports = __webpack_public_path__ + "img/qixiuchang.63b39bae.png";